/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Export model</h4>
<p>Export your model as STL or STEP.</p>`;

export default function ExportTooltip() {
    return h('div', { innerHTML: body });
}
